import { render, staticRenderFns } from "./MdAIDictationSpeech.vue?vue&type=template&id=9db972e0&"
import script from "./MdAIDictationSpeech.vue?vue&type=script&lang=js&"
export * from "./MdAIDictationSpeech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports